import React, { useEffect } from 'react';

interface Props {
  hide?: boolean;
  onSearch?: (searchTerm: string) => void;
  placeholder?: string;
}

const Search = ({ hide, onSearch, placeholder }: Props) => {
  // Subscribe to Search Events
  useEffect(() => {
    const search = document.querySelector('omnibar-search');

    if (!search || !onSearch) return;

    const searchSubmit = ((event: CustomEvent) => {
      const searchTerm = event.detail;

      onSearch(searchTerm);
    }) as EventListener;

    search.addEventListener('searchSubmit', searchSubmit);

    return () => {
      search.removeEventListener('searchSubmit', searchSubmit);
    };
  }, [onSearch]);

  return (
    <omnibar-search
      placeholder={placeholder || ''}
      // @ts-expect-error: slot "does not exist on type"
      slot="search"
      style={hide ? { display: 'none' } : {}}
    />
  );
};

export default Search;
